module.exports = __webpack_public_path__ + "img/profil.475c8b6b.jpg";